/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";

function SensorReading({ label = "", value = "--", unit = "", color = "grey" }) {
  const capitalize = (str) => (str ? str.charAt(0).toLocaleUpperCase("es-ES") + str.slice(1) : "");

  const formattedLabel = capitalize(label);

  const wrapper = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: 100,
    justifyContent: "flex-end",
  };

  const circle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 95,
    width: 95,
    maxWidth: 95,
    gap: 1,
    borderRadius: "50%",
    border: `3px solid ${color}`,
  };

  const labelStyle = {
    textAlign: "center",
    lineHeight: "1.1",
    marginBottom: "4px",
  };

  return (
    <div style={wrapper}>
      <MDTypography variant="body2" sx={labelStyle}>
        {formattedLabel}
      </MDTypography>

      <div style={circle}>
        <MDTypography variant="h5">{value}</MDTypography>

        {unit && (
          <MDTypography variant="h6" sx={{ fontSize: 15 }}>
            {unit}
          </MDTypography>
        )}
      </div>
    </div>
  );
}

SensorReading.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string,
  color: PropTypes.string,
};

export default SensorReading;
